import { useTranslation } from "react-i18next";
import { Box, Chip, Typography } from "@mui/material";

import { Service } from "../../types/service.type";
import { ServiceCardCompletedJobsIcon } from "../../assets/icons/go-service-icons";

const ServiceCardFooter = ({ service }: { service: Service }) => {
  const { t } = useTranslation("goService", { keyPrefix: "serviceCard" });
  const { t: tCurrency } = useTranslation("goService", { keyPrefix: "serviceCurrency" });
  const {
    completedJobs,
    paymentConfig: { amount, currency, type, unit },
  } = service;

  const amountLabel = `${tCurrency(currency)} ${amount / 100}`;
  return (
    <Box sx={styles.container}>
      <Typography sx={styles.completedJobsText}>
        <ServiceCardCompletedJobsIcon /> {t("completedJob", { count: completedJobs })}
      </Typography>

      <Chip label={unit ? t(unit, { amount: amountLabel }) : amountLabel} sx={styles.unitChip} />
    </Box>
  );
};

export default ServiceCardFooter;

const styles = {
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 16px 16px",
    height: "54px",
  },
  completedJobsText: {
    color: "var(--Dark---800, #414141)",
    fontFamily: "Montserrat",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  unitChip: {
    fontFamily: "Montserrat",
    color: "var(--Brand-600, #008B07)",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
    height: "fit-content",
    padding: "4px 12px",
    border: "1px solid var(--Green---50, #9FBFB6)",
    background: "var(--Green---25, #E7EFED)",
    "& .MuiChip-label": {
      padding: "0",
    },
  },
  fixedChip: {
    fontFamily: "Montserrat",
    color: "var(--White, #FFF)",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
    height: "fit-content",
    padding: "4px 12px",
    background: "var(--Brand-600, #008B07)",
    "& .MuiChip-label": {
      padding: "0",
    },
  },
};
